import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import { CloseButton } from '../CloseButton';
import { IAttachmentTagProps } from './AttachmentTag.types';
import { isNodeWiderThanParent } from '../../util/dom';

const AttachamentTagWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.background};
  margin-left: 16px;
  padding: 0 12px;
  margin-bottom: 4px;
`;

export const NoneButton = styled.button<{ stroked?: boolean }>`
  border: unset;
  background: unset;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
  }
`;

const TagButton = styled(NoneButton)`
  flex: 1;
  user-select: none;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.font2};
  width: 185px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TagCloseButton = styled(CloseButton)`
  float: right;
  img {
    color: ${({ theme }) => theme.colors.font2};
  }
`;

const AttachmentTag: React.FC<IAttachmentTagProps> = (
  props: IAttachmentTagProps
) => {
  const { name, onDelete, disallowRemove, onClick, testId } = props;
  const nameNodeRef = React.useRef(null);
  const shouldShowTooltip = isNodeWiderThanParent(nameNodeRef);
  const tooltipId = `Attachment${new Date().getTime()}`;

  return (
    <AttachamentTagWrapper data-testid={testId || 'attachment-tag'}>
      <TagButton
        type="button"
        onClick={onClick}
        data-tip={name}
        data-for={shouldShowTooltip ? tooltipId : ''}
      >
        <span ref={nameNodeRef}>{name}</span>
      </TagButton>
      {!disallowRemove ? (
        <TagCloseButton
          type="button"
          onClick={() => {
            if (onDelete) {
              onDelete(name);
            }
          }}
        >
          <i />
        </TagCloseButton>
      ) : null}
      {shouldShowTooltip && <ReactTooltip id={tooltipId} />}
    </AttachamentTagWrapper>
  );
};

export default AttachmentTag;
